import ConstructiveButton from '@/features/common/buttons/ConstructiveButton'
import DestructiveButton from '@/features/common/buttons/DestructiveButton'
import { useScreenLayout } from '@/hooks/screen'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface DefaultPostponeOrderButtonsProps {
    onBack: () => void
    postponeButtonDisabled: boolean
    onPostpone: () => Promise<void>
}

const DefaultPostponeOrderButtons: FC<DefaultPostponeOrderButtonsProps> = ({
    onBack,
    postponeButtonDisabled,
    onPostpone,
}) => {
    const [postponeLoading, setPostponeLoading] = useState(false)

    const screenLayout = useScreenLayout()

    const { t } = useTranslation()

    const handleOrderAccept = async () => {
        try {
            setPostponeLoading(true)

            await onPostpone()
        } finally {
            setPostponeLoading(false)
        }
    }

    const isCompactLayout = screenLayout === 'compact'

    return (
        <View style={styles.container}>
            <DestructiveButton icon disabled={postponeLoading} onPress={onBack}>
                {t('actions.back')}
            </DestructiveButton>
            <ConstructiveButton
                icon
                disabled={postponeButtonDisabled || postponeLoading}
                onPress={handleOrderAccept}
                style={{ maxWidth: 220 }}
            >
                {isCompactLayout ? t('actions.apply') : t('order.detail.acceptPostpone')}
            </ConstructiveButton>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        paddingHorizontal: 12,
        width: '100%',
        gap: 10,
    },
})

export default DefaultPostponeOrderButtons
